import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import scribeTheme from "./theme/scribeTheme";
import AppContent from "./components/layout/AppContent";
import { PaddleProvider } from "./contexts/PaddleContext";
import "./App.css";
import BrandHelmet from "./components/BrandHelmet";

const App: React.FC = () => (
  <ThemeProvider theme={scribeTheme}>
    <CssBaseline />
    <PaddleProvider>
      <Router>
        <BrandHelmet />
        <AppContent />
      </Router>
    </PaddleProvider>
  </ThemeProvider>
);

export default App;
